import { FC, HTMLAttributes } from 'react';
import clx from 'clsx';
import styles from './Card.module.css';

interface CardProps extends HTMLAttributes<HTMLDivElement> {}

export const Card: FC<CardProps> = ({ className, ...props }) => (
  <div className={clx(styles.card, className)} {...props} />
);
